import { useState } from "react";
import { Edit, ShowButton, SimpleForm, TextInput, useEditController, useNotify, useRedirect } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import { Grid, Typography, useMediaQuery, CircularProgress, Box } from "@mui/material";
import { getStyle } from "customStyles/utils";
import { settings } from "app";
import BaseForm from "./BaseForm";
import { EVENTS } from "utils/constants";
import ImagePreview from "./ImagePreview";
import { RichTextInput } from "ra-input-rich-text";
import PublicCustomImageInput from "components/EnrollingStudents/Partials/PublicCustomImageInput";

const EditAlumniEvent = () => {
  const { record } = useEditController();
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const [loadingSend, setLoadingSend] = useState(false);
  const redirect = useRedirect();
  const notify = useNotify();
  const style = getStyle(settings.tenant);
  const galeryIds = record?.article?.imageIds;
  const [eventLogoImageId, setEventLogoImageId] = useState(() => record?.imageId || null);
  const [isDisableEventUpload, setIsDisableEventUpload] = useState(false);
  const [imageGaleryIds, setImageGaleryIds] = useState(() => galeryIds || []);
  const [isDisableGalery, setIsDisableGalery] = useState(false);

  const [logoImageId, setLogoImageId] = useState(() => record?.article?.imageId || null);
  const [isDisable, setIsDisable] = useState(false);

  const convertData = (obj, keysToRemove = [], prefixesToRemove = []) => {
    const removedData = Object.fromEntries(
      Object.entries(obj)
        .filter(([key]) => !keysToRemove.includes(key) && !prefixesToRemove.some(prefix => key.startsWith(prefix)))
        .map(([key, value]) => {
          const dateKeys = ["startsAt"];

          if (typeof value === "string" && dateKeys.includes(key)) {
            value = value.split("T")[0];
          }

          return [key, value];
        }),
    );

    return removedData;
  };

  const handleSend = data => {
    setLoadingSend(true);
    const isArticle =
      data.article.content?.length > 0 ||
      data.article.title?.length > 0 ||
      data.article.subtitle?.length > 0 ||
      data.article.imageIds?.length > 0 ||
      data.article.imageId;

    return {
      ...convertData(
        data,
        ["imageId", "articleimageId", "articleimageIds"],
        ["imageId_", "articleimageId_", "articleimageIds_"],
      ),
      imageId: eventLogoImageId,
      article: isArticle
        ? {
            ...data.article,
            imageId: logoImageId,
            imageIds: imageGaleryIds,
          }
        : null,
    };
  };

  return (
    <div style={loadingSend ? { opacity: 0.5 } : { opacity: 1 }}>
      {loadingSend && (
        <div style={style.loadingStyle.container}>
          <CircularProgress size={200} />
          <div style={style.loadingStyle.text}>Saving...</div>
        </div>
      )}
      <Edit
        title="Редакция на събитие"
        mutationMode="pessimistic"
        actions={
          <BackButtonToolbar
            additionalButton={
              <ShowButton
                variant="contained"
                size="medium"
              />
            }
          />
        }
        transform={handleSend}
        mutationOptions={{
          onSuccess: data => {
            setLoadingSend(false);
            redirect(`/${EVENTS}`);
          },
          onError: error => {
            console.error(error);

            setLoadingSend(false);
            notify(error.message, { type: "error" });
          },
        }}
      >
        <SimpleForm>
          <BaseForm
            setEventLogoImageId={setEventLogoImageId}
            isDisableEventUpload={isDisableEventUpload}
            setIsDisableEventUpload={setIsDisableEventUpload}
            record={record}
          />
          <Grid
            container
            spacing={2}
            sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
          >
            <Grid
              item
              xs={12}
            >
              <Typography color="primary">Данни за статия</Typography>
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
            >
              <TextInput
                source="article.title"
                label="Заглавие на статия"
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
            >
              <TextInput
                source="article.subtitle"
                label="Подзаглавие на статия"
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={10}
            >
              <RichTextInput
                source="article.content"
                label="Съдържание на статия"
                variant="outlined"
                fullWidth
                sx={settings.style.richTextInput}
              />
            </Grid>
            <Grid
              item
              xs={12}
            >
              <Typography
                color="primary"
                sx={{ fontSize: "12px" }}
                fontWeight={"bold"}
                mb={2}
              >
                Водеща снимка
              </Typography>
              <ImagePreview id={record?.article?.imageId} />
              <PublicCustomImageInput
                helperText={".jpeg, .jpg, .png"}
                source="articleimageId"
                name="articleimageId"
                isDisable={isDisable}
                setIsDisable={setIsDisable}
                label={` `}
                SubCategoryId={13}
                setDataId={setLogoImageId}
              />
            </Grid>
            <Grid
              item
              xs={12}
            >
              <Typography
                color="primary"
                sx={{ fontSize: "12px" }}
                fontWeight={"bold"}
                mb={2}
              >
                Галерия снимки
              </Typography>
              <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                {galeryIds?.length > 0 ? (
                  galeryIds.map((image, idx) => {
                    return <ImagePreview id={image} />;
                  })
                ) : (
                  <p>Няма качени снимки</p>
                )}
              </Box>

              <PublicCustomImageInput
                helperText={".jpeg, .jpg, .png"}
                source="articleimageIds"
                name="articleimageIds"
                isDisable={isDisableGalery}
                setIsDisable={setIsDisableGalery}
                label={` `}
                SubCategoryId={13}
                setDataId={setImageGaleryIds}
                isMulty={true}
              />
            </Grid>
          </Grid>
        </SimpleForm>
      </Edit>
    </div>
  );
};

export default EditAlumniEvent;
